import { supabase } from "@/lib/supabase";

export interface PricingInsightMetricPayload {
  context: string;
  eventType: "request" | "response" | string;
  status?: string;
  itemId?: string;
  itemTitle?: string;
  itemCategory?: string;
  pricingSource?: string;
  latencyMs?: number;
  errorMessage?: string;
  metadata?: Record<string, unknown>;
}

export async function logPricingInsightMetric(
  payload: PricingInsightMetricPayload,
) {
  try {
    const {
      data: { session },
    } = await supabase.auth.getSession();

    if (!session?.access_token) {
      return;
    }

    await fetch("/api/metrics/pricing-insight", {
      method: "POST",
      headers: {
        Authorization: `Bearer ${session.access_token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });
  } catch (error) {
    console.error("Failed to log pricing insight metric", error);
  }
}
